import { render, staticRenderFns } from "./AutoPanel.vue?vue&type=template&id=2c10409a&"
import script from "./AutoPanel.vue?vue&type=script&lang=js&"
export * from "./AutoPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports